import io, { Socket } from 'socket.io-client';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

let socket: Socket;
const SOCKET_URL =
  process.env.REACT_APP_PROTOCOL + '://' + process.env.REACT_APP_DOMAIN;
const SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH;

const subscriptions: Record<string, (data: any) => void> = {};

const authenticateSocket = () => {
  if (!socket) {
    return;
  }

  const userCookies = cookies.get('user');
  if (userCookies?.access_token) {
    socket.emit('authenticate', userCookies.access_token);
  }
};

export const initiateSocket = () => {
  if (socket) {
    return;
  }

  socket = io(SOCKET_URL, {
    path: SOCKET_PATH,
    transports: ['polling', 'websocket'],
    closeOnBeforeunload: true,
    forceNew: true,
    tryAllTransports: true,
    withCredentials: true,
  });

  socket.on('connect', () => {
    authenticateSocket();

    const transport = socket.io.engine.transport.name; // in most cases, "polling"

    console.log('Connected with transport:', transport);

    socket.io.engine.on('upgrade', () => {
      const upgradedTransport = socket.io.engine.transport.name; // in most cases, "websocket"
      console.log(
          'Transport upgraded from',
          transport,
          'to',
          upgradedTransport,
      );
    });
  });

  socket.on('disconnect', (reason, details) => {
    console.log('Client disconnected, reconnecting', reason, details);
    ensureSocketConnected();
  });

  socket.on('connect_error', (error) => {
    console.log('Connection error, reconnecting', error.message);
    ensureSocketConnected();
  });
};

export const socketSubscribeTo = (emission, callback) => {
  if (!socket) {
    initiateSocket();
  }

  if (subscriptions[emission]) {
    socket.off(emission, subscriptions[emission]);
  }

  socket.on(emission, callback);
  subscriptions[emission] = callback;
};

export const socketUnsubscribeFrom = (emission) => {
  if (!socket) {
    return;
  }

  socket.off(emission);

  delete subscriptions[emission];
};

export const ensureSocketConnected = () => {
  if (!socket) {
    console.log('No existing socket, initiating');
    initiateSocket();
    return;
  }

  if (!socket.connected && !socket.active) {
    console.log('Existing socket not connected or inactive, reconnecting');
    socket.connect();
  }
};
